export { default } from './Note';
